// extracted by mini-css-extract-plugin
export default {"day_of_week_table":"style_day_of_week_table__t6Y9Z","day_td":"style_day_td__Zttj0","td_box":"style_td_box__EMKYX","active":"style_active__8OiGl"};